import { useMutationWithRefresh } from '../useMutationWithRefresh';
import deviceService from '../../services/deviceService';
import { queryKeys } from '../../queryClient';

// สร้างอุปกรณ์
export const useCreateDevice = (options?: { skipSuccessMessage?: boolean }) => {
  return useMutationWithRefresh({
    mutationFn: (data: any) => deviceService.createDevice(data),
    invalidateKeys: [
      queryKeys.devices.all,
      queryKeys.rentals.all, // rentals อาจแสดง dropdown อุปกรณ์
      queryKeys.dashboard.summary,
    ],
    successMessage: options?.skipSuccessMessage ? undefined : 'สร้างอุปกรณ์สำเร็จ',
  });
};

// แก้ไขอุปกรณ์
export const useUpdateDevice = () => {
  return useMutationWithRefresh({
    // BUG-S162-P1 rollout (S413): forward last-seen updated_at as ifMatch → stale write gets 409
    mutationFn: ({ id, data, ifMatch }: { id: number; data: any; ifMatch?: string }) => 
      deviceService.updateDevice(id, data, ifMatch),
    invalidateKeys: [
      queryKeys.devices.all,
      queryKeys.rentals.all, // rentals แสดงข้อมูลอุปกรณ์
      queryKeys.contracts.all, // contracts อ้างอิงอุปกรณ์
    ],
    successMessage: 'แก้ไขอุปกรณ์สำเร็จ',
  });
};

// ลบอุปกรณ์
export const useDeleteDevice = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => deviceService.deleteDevice(id),
    invalidateKeys: [
      queryKeys.devices.all,
      queryKeys.dashboard.summary,
    ],
    successMessage: 'ลบอุปกรณ์สำเร็จ',
  });
};

// อัพเดต Maintenance
export const useUpdateDeviceMaintenance = () => {
  return useMutationWithRefresh({
    mutationFn: ({ deviceId, data }: { deviceId: number; data: any }) =>
      (deviceService as any).updateMaintenance(deviceId, data),
    invalidateKeys: [
      queryKeys.devices.all,
    ],
    successMessage: 'อัพเดตข้อมูลการบำรุงรักษาสำเร็จ',
  });
};

// อัพเดต Notes
export const useUpdateDeviceNotes = () => {
  return useMutationWithRefresh({
    mutationFn: ({ deviceId, data }: { deviceId: number; data: any }) =>
      (deviceService as any).updateNotes(deviceId, data),
    invalidateKeys: [
      queryKeys.devices.all,
    ],
    successMessage: 'อัพเดตหมายเหตุสำเร็จ',
  });
};